/**
 * What a workspace's thresholds may be set to (uiv2 R3-3, R3-7). The settings
 * form's inputs and `PATCH /workspaces/:id/thresholds` both read these, so the
 * form cannot offer a value the route refuses. The DEFAULTS are not here: they
 * are the `workspaces` column defaults, read by the API
 * (`lib/workspace-thresholds.ts`) and sent to the client as the effective values.
 */
export const WORKSPACE_THRESHOLD_BOUNDS = {
    /** Weekly hours past which an employee's time counts as overtime (a week has 168). */
    overtimeWeeklyHours: { min: 1, max: 168 },
    /** The change, in percent either way, past which a biller reads as growing or shrinking. */
    billerTrendBandPercent: { min: 0, max: 100 },
};
//# sourceMappingURL=workspace-thresholds.js.map